var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuoteIconBranded = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 101,
  height: 117,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#quote_icon_branded_svg__a)",
  fillRule: "evenodd",
  d: "M59.634 97.272C83.164 93.098 101 73.09 101 49.036 101 21.954 78.39 0 50.5 0S0 21.954 0 49.036c0 23.876 17.573 43.766 40.845 48.141l9.418 19.449z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M75.753 50.413V29.41H54.752v21.002h14c0 7.72-6.28 14-14 14v7.001c11.58 0 21.001-9.42 21.001-21.001M26.75 64.414v7c11.581 0 21.002-9.42 21.002-21.001V29.41H26.75v21.002h14.001c0 7.72-6.28 14-14 14"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "quote_icon_branded_svg__a",
  x1: 50.5,
  x2: 50.5,
  y1: 0,
  y2: 99.075,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F8C31C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FFDE37"
})))));
export default SvgQuoteIconBranded;